import { createContext, ReactElement, useCallback, useContext } from 'react';

import type { NavbarProps } from '../../types';

type ClientPropsFunction = () => NavbarProps;

export const ClientPropsContext = createContext<ClientPropsFunction>(() => {
  throw new Error('ClientPropsContext used before being provided');
});

type Props = { profileDropdownProps: NavbarProps; children: ReactElement };
export function ClientPropsProvider(props: Props) {
  const { profileDropdownProps, children } = props;

  const value = useCallback(() => {
    return { ...profileDropdownProps };
  }, [profileDropdownProps]);

  return <ClientPropsContext.Provider value={value}>{children}</ClientPropsContext.Provider>;
}

export function useClientProps(): NavbarProps {
  return useContext(ClientPropsContext)();
}
